import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { EmailStatusBadge, AudienceBadge, purposeLabel, fmtWhen } from './emailMeta';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const BAD = ['failed', 'bounced', 'suppressed', 'complained'];

/** Email history for one lead, customer or inquiry (pass exactly one id). */
export const EmailActivity = ({ leadId, customerId, inquiryId, headers }) => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    const params = { lead_id: leadId, customer_id: customerId, inquiry_id: inquiryId };
    axios.get(`${API_URL}/api/admin/emails`, { headers, params })
      .then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [leadId, customerId, inquiryId, headers]);

  const failed = (items || []).filter((e) => BAD.includes(e.status) && e.retryable).length;
  return (
    <div className="bg-white border border-zinc-200 rounded-xl p-4" data-testid="email-activity">
      <div className="flex items-center gap-2 mb-3">
        <Mail className="w-4 h-4 text-orange-600" />
        <p className="text-xs font-semibold text-zinc-600 uppercase tracking-wide">Email activity</p>
        {failed > 0 && <Link to="/admin/emails/failed" className="ml-auto text-xs font-semibold text-red-700 hover:underline" data-testid="email-activity-review-link">Review failed emails ({failed})</Link>}
      </div>
      {items === null && <p className="text-sm text-zinc-400">Loading…</p>}
      {items?.length === 0 && <p className="text-sm text-zinc-400" data-testid="email-activity-empty">No emails recorded yet.</p>}
      <div className="divide-y divide-zinc-100">
        {items?.map((e) => (
          <div key={e.id} className="py-2.5" data-testid={`email-row-${e.id}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <p className="text-sm font-medium text-zinc-900 truncate" title={e.subject}>{e.subject}</p>
                <p className="text-xs text-zinc-500 truncate">To {e.to} · {purposeLabel(e.purpose)}</p>
              </div>
              <div className="text-right shrink-0 space-y-1">
                <EmailStatusBadge status={e.status} testId={`email-status-${e.id}`} />
                <p className="text-[11px] text-zinc-400">{fmtWhen(e.created_at)}</p>
              </div>
            </div>
            <div className="flex flex-wrap items-center gap-2 mt-1">
              <AudienceBadge audience={e.audience} />
              {e.retry_of && <span className="text-[11px] text-zinc-500">Retry of an earlier send</span>}
              {e.retried_as && <span className="text-[11px] text-zinc-500">Retried</span>}
            </div>
            {e.error && <p className="text-xs text-red-600 mt-1 break-words" data-testid={`email-error-${e.id}`}>{e.error}</p>}
          </div>
        ))}
      </div>
    </div>
  );
};
